import { Flex } from 'foundations-components/components/Flex';
import { useGetSourceCitationHoverContent } from '../input/hoverContent/hooks/useGetSourceCitationHoverContent';
import { useGetDetailsLinkButton } from '../input/hoverContent/hooks/useGetDetailsLinkButton';
import { useGetCommunicationLink } from '../input/hoverContent/hooks/useGetCommunicationLink';
import { useMemo } from 'react';

/**
 * This JSX is a hook instead of a component because we need to check conditionally whether the rendered result is truthy/falsy,
 * in order to be able to not pass content to FormControl's hoverContent prop.
 *
 * Were this a component, its 'value' would always be truthy and we would wind up passing empty, but present, hover content.
 */
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useGetDefaultHoverContent = ({
  onDetailsClick,
  displayOptimized
}) => {
  const communicationLink = useGetCommunicationLink(displayOptimized);
  const sourceCitationHoverContent = useGetSourceCitationHoverContent();
  const detailsLinkButton = useGetDetailsLinkButton(displayOptimized, onDetailsClick);
  return useMemo(() => {
    if (!communicationLink && !sourceCitationHoverContent && !detailsLinkButton) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Flex, {
      gap: "200",
      flexWrap: "nowrap",
      alignItems: "center",
      marginBlockStart: "250",
      children: [communicationLink, sourceCitationHoverContent, detailsLinkButton]
    });
  }, [communicationLink, sourceCitationHoverContent, detailsLinkButton]);
};